/**
 * Public surface of the typing engine. Import from here, not from internal
 * modules, so refactors stay contained.
 *
 * @module typing-engine
 */
export { createEngine, summarize } from './engine';
export {
  grossWpm,
  netWpm,
  accuracy,
  round2,
  isLeaderboardEligible,
  CHARS_PER_WORD,
  SECONDS_PER_MINUTE,
} from './formulas';
export { TEST_PASSAGES, pickPassage } from './passages';